"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _index = require("../../provider/ThemeProvider/index");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * A headline component providing styled h1, h2, h3 or h4 headline elements
 *
 * @param	{1|2|3|4}	size			The headlines hierarchy (h1 to h4)
 * @param	{string}	color			A css conform hex/rgb/rgba color code
 * @param	{boolean}	noMargin	Wether or not to render the componentn with margin
 * @param	{boolean}	center		Wether or not to center the content
 * @param	{string}	textAlign	The headings text align
 * @param	{boolean}	pseudo	  Wether or not to render as a real HTML heading element
 * @param	{content}	children	The headlines content
 **/
var Headline = function Headline(_ref) {
  var size = _ref.size,
      children = _ref.children,
      color = _ref.color,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? false : _ref$center,
      _ref$textAlign = _ref.textAlign,
      textAlign = _ref$textAlign === void 0 ? 'left' : _ref$textAlign,
      _ref$pseudo = _ref.pseudo,
      pseudo = _ref$pseudo === void 0 ? false : _ref$pseudo,
      globalThemeVariant = _ref.globalThemeVariant,
      globalThemeSubVariant = _ref.globalThemeSubVariant,
      className = _ref.className,
      displayAs = _ref.displayAs,
      _ref$important = _ref.important,
      important = _ref$important === void 0 ? false : _ref$important;
  // "Legacy" support
  textAlign = center ? 'center' : textAlign;
  var combinedClassName = "\n  ".concat(_styleModule.default['heading' + (displayAs || size)], " ").concat(important ? _styleModule.default.important : '', " ").concat(_styleModule.default[globalThemeVariant], " ").concat(_styleModule.default[globalThemeSubVariant], " ").concat(noMargin && _styleModule.default.noMargin, " ").concat(className, "\n    ");

  var Base = function Base(props) {
    return pseudo ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: combinedClassName,
      children: children
    }) : size === 1 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _extends2.default)({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 2 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _extends2.default)({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 3 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", (0, _extends2.default)({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 4 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h4", (0, _extends2.default)({
      className: combinedClassName
    }, props, {
      children: children
    })) : size === 5 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h5", (0, _extends2.default)({
      className: combinedClassName
    }, props, {
      children: children
    })) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _extends2.default)({
      className: combinedClassName
    }, props, {
      children: children
    }));
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Base, {
    style: {
      color: color,
      textAlign: textAlign
    },
    children: children
  });
};

var _default = /*#__PURE__*/React.memo((0, _index.withThemeVariant)(Headline), function (prev, next) {
  return prev.children === next.children;
});

exports.default = _default;